var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Search(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-search",
    className: "cls-1",
    d: "M14.951,6a8.951,8.951,0,1,0,5.383,16.081l3.559,3.558a1.235,1.235,0,1,0,1.746-1.746l-3.558-3.559A8.93,8.93,0,0,0,14.951,6Zm0,2.469a6.483,6.483,0,0,1,4.721,10.924,1.235,1.235,0,0,0-.276.276,6.482,6.482,0,1,1-4.445-11.2Z",
    transform: "translate(-6 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Search);
export default __webpack_public_path__ + "static/media/icons8-search.4a1967382df0ee6b5c99fa4398f4417f.svg";
export { ForwardRef as ReactComponent };